import React, { useEffect, useState } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  deleteModuleToRole,
  getModuleToModuleToRoles,
} from "../../../../services/ModuleToRoleService";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";

const ListModuleToRole = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    try {
      const response = await getModuleToModuleToRoles();
      setData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteModuleToRole(id);
      getList();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "roleSlug", title: "Role" },
    { prop: "modules", title: "Modules" },
    { prop: "operations", title: "Operations" },
    { prop: "createdAt", title: "Created At" },
    { prop: "updatedAt", title: "Updated At" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            style={{ border: "0px" }}
            to={`/settings/mtr/edit/${row._id}`}
            className="waves-effect bg-primary btn btn-success btn-sm me-2"
          >
            <i className="ti ti-pencil"></i>
          </Link>
          <Button
            className="waves-effect waves-circle btn btn-danger btn-sm"
            onClick={() => handleDelete(row._id)}
          >
            <i className="ti ti-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = data.map((item) => ({
    roleSlug: item.roleSlug,
    modules: item.modules.map((module) => module.value).join(", "),
    operations: item.modules
      .map(
        (module) => `${module.value}: ${module.operations.join(", ")}`
      )
      .join("; "),
    createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
    updatedAt: moment(item.updatedAt).format("YYYY-MM-DD"),
    _id: item._id, // Include for delete/edit actions
  }));

  // Filter the data based on the role slug
  const filteredData = tableData.filter(
    (item) =>
      item.roleSlug &&
      item.roleSlug.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col xs={12}>
              <h4 className="box-title">Module To Role List</h4>
              <Link
                to="/settings/mtr/add"
                className="waves-effect btn btn-primary btn-small float-end"
                style={{ marginTop: "-4px" }}
              >
                Add Module to Role
              </Link>

              <DatatableWrapper
                body={filteredData} // Use filtered data for the table
                headers={header}
                paginationOptionsProps={{
                  initialState: {
                    rowsPerPage: 5, // Set rows per page
                    options: [5, 10, 15], // Options for rows per page
                  },
                }}
              >
                <Row className="mb-4">
                  <Col
                    xs={12}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Search by Role"
                      value={filterText}
                      onChange={(e) => setFilterText(e.target.value)}
                    />
                  </Col>
                </Row>

                <Table responsive className="tableList">
                  <TableHeader />
                  <TableBody />
                </Table>

                <Row>
                  <Col className="d-flex flex-col justify-content-start">
                    <PaginationOptions />
                  </Col>
                  <Col className="mt-4 d-flex flex-col justify-content-end align-items-end">
                    <Pagination />
                  </Col>
                </Row>
              </DatatableWrapper>
            </Col>
          </Row>
        </div>
      </Card>
    </>
  );
};

export default ListModuleToRole;
